<template>
    <div class="content">
        <h1>Manage Affiliate Partners</h1>
        <section class="w-100">
            <h2>Affiliate Partner Infos</h2>
            <input
                id="users-search-input"
                type="text"
                v-model="searchValue"
                class="form-control-search main-form-control @error('search') is-invalid @enderror"
                name="search"
                placeholder="Search by Affiliate ID"
            />
            <b-table
                class="table-responsive"
                id="allUsersTable"
                :items="filteredAffiliatePartners"
                :fields="fields"
                responsive="lg"
                :per-page="perPage"
                :current-page="currentPage"
            >
            </b-table>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'AffiliatesAdmin',
        data() {
            return {
                affiliatePartners: [],
                fields: [
                    { key: 'affiliate_code', sortable: true },
                    { key: 'affiliate_name', sortable: true },
                    { key: 'first_name', sortable: true },
                    { key: 'last_name', sortable: true },
                    { key: 'email', sortable: true },
                    { key: 'phone', sortable: true },
                    { key: 'referred', sortable: true }
                ],
                perPage: 50,
                currentPage: 1,
                searchValue: ''
            }
        },
        computed: {
            filteredAffiliatePartners: (self) => {
                return self.affiliatePartners.filter((affiliate) => {
                    return affiliate.affiliate_code.includes(self.searchValue.toLowerCase())
                })
            }
        },
        async created() {
            await this.fetchAffiliatePartners()
        },
        methods: {
            async fetchAffiliatePartners() {
                try {
                    const response = await axios.get('/admin/affiliates/all')
                    this.affiliatePartners = response.data.data
                } catch (error) {
                    console.error(error)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .content {
        gap: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
</style>
